import React, { ReactElement } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';

import "./optionTabs.scss";

interface Props<TypeOptionTabs> {
    tabDetails: TabOption[];
    setState: any;
    setStateValue: number;
};

interface TabOption {
    title: string;
    icon: string;
    tabKey: number
};

export default function OptionTabs<TypeOptionTabs>({ tabDetails, setState, setStateValue }: Props<TypeOptionTabs>): ReactElement {
    return (
        <Nav> {/*  tabs */}
            {
                tabDetails?.map((eachTab, index) => (
                    <React.Fragment key={index}>
                        <NavItem onClick={() => setState(eachTab.tabKey)}>
                            <NavLink
                                className={"pointer " + (setStateValue === eachTab.tabKey ? "activeTab" : "")}>
                                <i className={eachTab.icon}></i> {eachTab.title}
                            </NavLink>
                            {/* style={ setStateValue === eachTab.tabKey ? { borderBottom: '2px solid darkblue' } : {} } */}
                        </NavItem>
                    </React.Fragment>
                ))
            }
        </Nav>
    )
}
